import React, {useEffect} from 'react';
import withHeader from "../../../hocs/withHeader";
import SocialChannelsButtonsWrapper from "../social_channels/SocialChannelsButtonsWrapper";
import RegisterForm from "./RegisterForm";
import {clearCredentials} from "../../../../slices/userSlice";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import ErrorBoundary from "../../../meta/ErrorBoundary";
import withFooter from "../../../hocs/withFooter";

function Register(props) {
    useEffect(() => {
        props.clearCredentials();
    }, []);

    return (
        <section className="register">
            <div className="container">
                <ErrorBoundary boundaryName="Register Form">
                    <h1 className="pt-md pb-xl">Create your free account</h1>
                    <RegisterForm/>
                </ErrorBoundary>

                <div className="alternative_login pv-xl">
                    <p className="alternative_login__title">Or sign up with:</p>
                    <ErrorBoundary boundaryName="Social Authentication Buttons">
                        <SocialChannelsButtonsWrapper/>
                    </ErrorBoundary>
                    <p className="alternative_login__login pb-xl">Already signed up? <Link to="/login">Log in</Link></p>
                    <div className="alternative_login__benefits">
                        <div className="alternative_login__benefits__title pb-sm">Included for free:</div>
                        <div className="alternative_login__benefits__list">
                            <div className="alternative_login__benefits__list__col">
                                <span className="pb-xs"><span
                                    className="alternative_login__benefits__list__col__symbol">+</span> Unlimited surveys</span>
                                <span><span className="alternative_login__benefits__list__col__symbol">+</span> Template gallery access</span>
                            </div>
                            <div className="alternative_login__benefits__list__col">
                                <span className="pb-xs"><span
                                    className="alternative_login__benefits__list__col__symbol">+</span> Unlimited respondents</span>
                                <span><span className="alternative_login__benefits__list__col__symbol">+</span> PPT, CSV, Web reports</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}

const mapDispatchToProps = {clearCredentials};

export default connect(null, mapDispatchToProps)(withFooter(withHeader(Register)));